import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import RadioInput from 'components/RadioInput';
import { ITableModel } from 'components/Table/interface';
import { modelLinkTicket } from 'components/Table/Tickets/models';
import LinkTicketProtocol from 'components/Table/LinkTicketProtocol';

const LinkProtocol: React.FC<any> = (props) => {

  const pageSize = 10;

  const {
    setLinkProtocol,
    setSelectedLinkProtocol,
    selectedLinkProtocol,
    protocolNumber,
    linkProtocolNumber,
    isEditing,
    customerId
  } = props;

  const protocols = useSelector((state: RootState) => state.protocol.protocols);
  const [protocolSelectedId, setProtocolSelectedId] = useState('');

  const editButtonLabel: ITableModel = {
    label: 'Protocolo',
    key: 'protocolNumber',
    size: 150,
    maxSize: 150,
  };

  const ticketModelEdit: Array<ITableModel> = [editButtonLabel, ...modelLinkTicket];

  useEffect(() => {
    const protocolSelected = protocols?.find(
      (protocol: any) => protocol.protocolNumber === JSON.stringify(linkProtocolNumber));

    setProtocolSelectedId(protocolSelected?.id);
  }, [protocols]);

  useEffect(() => {
    if (linkProtocolNumber) {
      setSelectedLinkProtocol(true);
    }
  }, []);

  const handleSelectLinkProtocol = (value: boolean) => {
    setSelectedLinkProtocol(value);
    setLinkProtocol("");
  };

  return (
    <>
      <Column className="mt-5">
        <Text className="mb-2 color-blue-gray" size={12}>
          Vincular protocolo antigo
        </Text>
        <Row className="flex-md-column">
          <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
            <RadioInput
              id="NO"
              onClick={() => handleSelectLinkProtocol(false)}
              checked={!selectedLinkProtocol}
            >
              <Text className="color-blue-gray">Não</Text>
            </RadioInput>
          </Row>
          <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
            <RadioInput
              id="YES"
              onClick={() => handleSelectLinkProtocol(true)}
              checked={selectedLinkProtocol}
            >
              <Text className="color-blue-gray">Sim</Text>
            </RadioInput>
          </Row>
        </Row>
      </Column>

      {selectedLinkProtocol && (
        <>
          <Column>
            <Text className="mt-6 mb-1 color-blue-gray" size={12} weight="bold">
              Selecione o protocolo que gostaria de vincular
            </Text>
          </Column>

          <LinkTicketProtocol
            trackingKey="Protocolos"
            pageSize={pageSize}
            protocolNumber={protocolNumber}
            model={[
              {
                label: '',
                Component: (data: any) => (
                  <Row>
                    <input
                      name="protocolSelected"
                      type="radio"
                      onClick={() => setLinkProtocol(data.protocolNumber)}
                      value={data.id}
                      defaultChecked={linkProtocolNumber && data.id === protocolSelectedId ? true : false}
                    />
                  </Row>
                ),
                size: 40,
                maxSize: 40,
              },
              ...ticketModelEdit]}
            showFilter
            initialOrder="createdDate desc"
            isEditing={isEditing}
            customerId={customerId}
          />
        </>
      )}
    </>
  );
};

export default LinkProtocol;
